import React from 'react';
import { NotebookPen, ChevronRight } from 'lucide-react';
import { tint } from './primitives';
import { useStoredValue } from '../../../services/deviceStore';

/** Full-width card that previews this rotation's personal note and opens it */
const NotesCard = ({ storageKey, accent, onOpen }) => {
  const parsed = useStoredValue(storageKey, null);
  const savedAt = parsed?.savedAt || null;
  const hasNote = Boolean((parsed?.text || '').trim());

  return (
    <button
      onClick={() => { onOpen(); }}
      className="w-full text-left bg-white dark:bg-gray-800 rounded-2xl p-4 flex items-center gap-4 border"
      style={{ borderColor: tint(accent, 0.45), boxShadow: `0 0 0 3px ${tint(accent, 0.10)}, 0 6px 18px ${tint(accent, 0.18)}` }}
    >
      <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: accent, color: 'white' }}>
        <NotebookPen size={22} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-[15px] leading-tight text-gray-900 dark:text-white">My Notes</div>
        <div className="text-xs mt-1 leading-snug text-gray-500 dark:text-gray-400">
          {hasNote && savedAt
            ? `Edited ${new Date(savedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`
            : 'Your own notes for this rotation. Tap to start.'}
        </div>
      </div>
      <ChevronRight size={18} className="text-gray-300 dark:text-gray-600 flex-shrink-0" />
    </button>
  );
};

export default NotesCard;
